module.exports = __webpack_public_path__ + "static/img/image2.ae590402.png";